/*********************************************************************************************
 * Initialize the sticky CTA behavior.
 */
function initStickyCTA() {
	let dernierePositionDeScrollConnue = 0;
	let ticking = false;
	const CTA = document.querySelector(".mm-main-product-button-container");

	if (CTA) {
		const CTA_position = CTA.offsetTop - window.innerHeight / 3;

		/**
		 * Add or remove the sticky class to the CTA based on scroll position.
		 *
		 * @param {number} position_scroll - The current scroll position.
		 */
		function toggleStickyCTA(position_scroll) {
			if (position_scroll > CTA_position) {
				CTA.classList.add("mm-cta-sticky");
			} else {
				CTA.classList.remove("mm-cta-sticky");
			}
		}

		window.addEventListener("scroll", () => {
			dernierePositionDeScrollConnue = window.scrollY;

			if (!ticking) {
				ticking = true;

				window.requestAnimationFrame(() => {
					toggleStickyCTA(dernierePositionDeScrollConnue);
					ticking = false;
				});
			}
		});
	}
}

/*********************************************************************************************
 * Initialize the Splide carousel for the main product slider.
 */
function mmSlideProduct() {
	var splideElemMain = document.querySelector("#main-slider");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "loop",
			pagination: false,
			arrows: true,
			perPage: 1,
			destroy: true,
			breakpoints: {
				768: {
					destroy: false,
					padding: {
						right: 40,
					},
				},
			},
		});
		main.mount();
	}
}

/*********************************************************************************************
 * Initialize the Splide carousel for the bundle bloc.
 */
function mmSlideBundleProducts() {
	var splideElemBundle = document.querySelector("#bundle-slider");

	if (splideElemBundle) {
		var slideCount = splideElemBundle.querySelectorAll(".splide__slide").length;
		var bundle = new Splide(splideElemBundle, {
			type: "slide",
			pagination: false,
			arrows: slideCount > 1,
			perPage: 1,
			gap: "12px",
			padding: {
				right: slideCount > 1 ? "33%" : "0",
			},
		});
		bundle.mount();
	}
}

/************************************************************************************************/
// Class for handling variant selection
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	 * Handle variant change event.
	 */
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			this.variantFetch();
			mmCloseD();
		}
	}

	/*********************************************************************************************
	 * Get selected options from the variant checkboxes.
	 */
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	 * Get variant data from the embedded JSON.
	 *
	 * @returns {Object} - The variant data.
	 */
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	 * Get the selected variant based on selected options.
	 */
	getSelectedVariant() {
		const options = this.options;
		this.currentVariant = this.getVariantJSON().find((variant) => {
			return options.every((option, index) => option === variant.options[index]);
		});
	}

	/*********************************************************************************************
	 * Update the URL to include the selected variant ID.
	 */
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	 * Fetch variant data from the server and cache it.
	 */
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	 * Render variant information in the DOM.
	 *
	 * @param {Document} html - The HTML document containing the variant information.
	 */
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter(".mm-product-price", html);
		this.updateElementOuter(".mm-product-variants", html);
		this.updateElementOuter(".mm-product-cta", html);
		this.updateElementOuter(".mm-product-variants-picker", html);
		this.updateElementOuter(".mm-product-form-variant-value", html);
		this.updateElementOuter(".mm-product-form-sku", html);
		this.updateElementOuter(".mm-main-product-label-special", html);
		this.updateQuantity(html);
	}

	/*********************************************************************************************
	 * Update the inner HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	 * Update the quantity input and buttons based on the selected variant.
	 *
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateQuantity(html) {
		const quantityInput = this.container.querySelector('input[name="quantity"]');
		const newQuantityInput = html.querySelector('input[name="quantity"]');

		if (quantityInput && newQuantityInput) {
			const maxQuantity = newQuantityInput.getAttribute("data-max");
			quantityInput.setAttribute("max", maxQuantity);
			quantityInput.setAttribute("data-max", maxQuantity);

			quantityInput.value = 1;

			const decreaseButton = this.container.querySelector(`[onclick="mmChangeQtty(-1, '${quantityInput.id}')"]`);
			const increaseButton = this.container.querySelector(`[onclick="mmChangeQtty(1, '${quantityInput.id}')"]`);

			if (decreaseButton) {
				decreaseButton.disabled = true;
			}

			if (increaseButton) {
				increaseButton.disabled = parseInt(maxQuantity) <= 1;
			}
			
			// Mettre à jour le prix après changement de variant
			mmUpdatePrice(1);
		}
	}
}

/************************************************************************************************/
// Define the custom element
customElements.define("variant-selector", VariantSelector);

/************************************************************************************************/
// Loaded Listenner
document.addEventListener("DOMContentLoaded", () => {
	mmSlideProduct();
	mmSlideBundleProducts();
	// mmSlideProductReassurance();
	initStickyCTA();
});

/************************************************************************************************/
// Change quantity
function mmChangeQtty(change, inputId) {
	var input = document.getElementById(inputId);
	var currentQuantity = parseInt(input.value);
	var maxQuantity = parseInt(input.getAttribute("data-max"));
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);
	const warningMessage = document.querySelector('.mm-quantity-warning');

	if (change === -1 && input.value === "1") {
		return;
	} else {

		var newQuantity = parseInt(input.value, 10) + parseInt(change, 10);
		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé

	if (input.max && newQuantity >= parseInt(input.max, 10)) {
		newQuantity = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
			if (warningMessage) {
				warningMessage.classList.remove("mm-none");
				warningMessage.classList.add("mm-show");
			}
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
			if (warningMessage) {
				warningMessage.classList.remove("mm-show");
				warningMessage.classList.add("mm-none");
			}
		}
		// var decreaseButton = document.querySelector(`[onclick="mmChangeQtty(-1, '${inputId}')"]`);
		// var increaseButton = document.querySelector(`[onclick="mmChangeQtty(1, '${inputId}')"]`);

		// decreaseButton.disabled = newQuantity <= 1;
		// increaseButton.disabled = newQuantity >= maxQuantity; 
		// Mise à jour de la valeur de l'input
		input.value = newQuantity;
	}
	mmUpdatePrice(newQuantity);
}

// Prevent from 

document.addEventListener('DOMContentLoaded', function () {
    const quantityInputs = document.querySelectorAll('input[name="quantity"]');

    quantityInputs.forEach(function(input) {
		input.addEventListener('input', function () {
			const max = parseInt(input.getAttribute('max'), 10);
			const min = parseInt(input.getAttribute('min'), 10) || 1;
			let value = parseInt(input.value, 10);

			if (isNaN(value)) {
				value = min;
			}
			const warningMessage = document.querySelector('.mm-quantity-warning');

			if (value >= max) {
				input.value = max;
				if (warningMessage) {
					warningMessage.classList.remove('mm-none');
					warningMessage.classList.add('mm-show');
				}
			} else {
				if (value < min) {
					input.value = min;
				}
				if (warningMessage) {
					warningMessage.classList.remove('mm-show');
					warningMessage.classList.add('mm-none');
				}
			}
			
			const finalQuantity = parseInt(input.value, 10) || 1;
			
			// Mettre à jour le prix en fonction de la quantité
			mmUpdatePrice(finalQuantity);
		});
	});
});

/*********************************************************************************************
 * Update the displayed prices based on the new quantity.
 *
 * @param {number} qtty - The current product quantity used to calculate the prices.
 */
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]:not(.mm-product-samples-card)");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			var calculatedPrice = (priceValue * qtty) / 100;
			price.innerHTML = calculatedPrice % 1 === 0 ? Math.floor(calculatedPrice) + " €" : calculatedPrice.toFixed(2) + " €";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			var calculatedComparePrice = (comparePriceValue * qtty) / 100;
			comparePrice.innerHTML = calculatedComparePrice % 1 === 0 ? Math.floor(calculatedComparePrice) + " €" : calculatedComparePrice.toFixed(2) + " €";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/************************************************************************************************/
// PRODUCT FORM PANEL
function mmOpenD(optionName) {
	document.querySelector(`.mm-product-form-panel-wrapper-${optionName}`).classList.remove("mm-hidden");
	document.querySelector("html").classList.add("stop-scrolling");
}

function mmCloseD() {
	document.querySelectorAll(".mm-product-form-panel-wrapper").forEach((panel) => {
		panel.classList.add("mm-hidden");
	});
	document.querySelector("html").classList.remove("stop-scrolling");
}

/************************************************************************************************/
// Initialiser le prix au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
	setTimeout(function() {
		const quantityInput = document.querySelector('input[name="quantity"]');
		if (quantityInput) {
			const initialQuantity = parseInt(quantityInput.value, 10) || 1;
			mmUpdatePrice(initialQuantity);
		}
	}, 100);
});

/************************************************************************************************/
// SAMPLES

const mmCartSamples = new Set();
const mmSelectedSamples = new Set();

/*********************************************************************************************
 * Handle the add-to-cart button click with bundle upsell logic.
 * - First click when a matching bundle exists: show the bundle modal.
 * - Subsequent clicks (or no matching bundle): add to cart directly.
 *
 * @param {HTMLElement} btn         - The ATC button element.
 * @param {string}      variantId   - The variant ID to add to cart.
 * @param {string}      inputId     - The quantity input ID.
 * @param {string}      modalId     - The bundle modal element ID.
 */
function mmHandleBundleATC(btn, variantId, inputId, modalId) {
	const quantityInput = document.getElementById(inputId);
	const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
	const modal = document.getElementById(modalId);
	const proposedQuantities = btn.dataset.bundleProposed ? btn.dataset.bundleProposed.split(',') : [];
	const alreadyProposedForQuantity = proposedQuantities.includes(String(quantity));

	if (!alreadyProposedForQuantity && modal) {
		const matchingItem = modal.querySelector(`.mm-bundle-modal-item[data-pieces="${quantity}"]`);
		if (matchingItem) {
			proposedQuantities.push(String(quantity));
			btn.dataset.bundleProposed = proposedQuantities.join(',');
			mmOpenBundleModal(modal, matchingItem);
			return;
		}
	}

	mmAddProductToCart(variantId, { quantity, openCart: false });
	showCartToast();
}

/*********************************************************************************************
 * Open the bundle modal and show only the matching bundle item.
 *
 * @param {HTMLElement} modal     - The modal element.
 * @param {HTMLElement} matchItem - The bundle item to display.
 */
function mmOpenBundleModal(modal, matchItem) {
	modal.querySelectorAll('.mm-bundle-modal-item').forEach(function(el) {
		el.style.display = 'none';
	});
	matchItem.style.display = 'block';

	if (modal.parentElement !== document.body) {
		document.body.appendChild(modal);
	}

	modal.classList.remove('mm-none');
	modal.classList.add('mm-flex');
	document.querySelector('html').classList.add('stop-scrolling');
}

/*********************************************************************************************
 * Close the bundle modal.
 */
function mmCloseBundleModal() {
	document.querySelectorAll('.mm-bundle-modal').forEach(function(modal) {
		modal.classList.remove('mm-flex');
		modal.classList.add('mm-none');
	});
	document.querySelector('html').classList.remove('stop-scrolling');
}

/************************************************************************************************/
function mmOpenSamplesModal() {
	const modal = document.getElementById("mm-sample-modal");
	if (!modal) return;
	modal.classList.remove("mm-none");
	modal.classList.add("mm-flex");
	document.querySelector("html").classList.add("stop-scrolling");
	mmSyncSamplesWithCart();

	if (!modal.dataset.boundClose) {
		modal.addEventListener("click", function(e) {
			if (e.target === modal) mmCloseSamplesModal();
		});
		modal.querySelector(".mm-modal-close").addEventListener("click", mmCloseSamplesModal);
		modal.dataset.boundClose = "true";
	}
}

function mmCloseSamplesModal() {
	const modal = document.getElementById("mm-sample-modal");
	if (!modal) return;
	modal.classList.add("mm-none");
	modal.classList.remove("mm-flex");
	document.querySelector("html").classList.remove("stop-scrolling");
}

function toggleSampleSelection(event, variantId) {
	if (event.target.closest(".mm-remove-sample")) {
		mmSelectedSamples.delete(variantId);
		mmSetModalCardState(variantId, "default");
		mmUpdateSamplesCTA();
		return;
	}

	if (mmSelectedSamples.has(variantId)) {
		mmSelectedSamples.delete(variantId);
		mmSetModalCardState(variantId, "default");
	} else {
		mmSelectedSamples.add(variantId);
		mmSetModalCardState(variantId, "selected");
	}
	mmUpdateSamplesCTA();
}

// state: "default" | "selected" | "in-cart"
function mmSetModalCardState(variantId, state) {
	const card = document.querySelector(".mm-product-samples-modal [data-variant-id=\"" + variantId + "\"]");
	if (!card) return;

	card.querySelector(".mm-sample-overlay")?.classList.add("mm-none");
	card.querySelector(".mm-sample-overlay-in-cart")?.classList.add("mm-none");
	card.querySelector(".mm-sample-add-to-btn")?.classList.remove("mm-none");
	card.querySelector(".mm-sample-added")?.classList.add("mm-none");
	card.querySelector(".mm-sample-in-cart")?.classList.add("mm-none");

	if (state === "selected") {
		card.querySelector(".mm-sample-overlay")?.classList.remove("mm-none");
		card.querySelector(".mm-sample-add-to-btn")?.classList.add("mm-none");
		card.querySelector(".mm-sample-added")?.classList.remove("mm-none");
	} else if (state === "in-cart") {
		card.querySelector(".mm-sample-overlay-in-cart")?.classList.remove("mm-none");
		card.querySelector(".mm-sample-add-to-btn")?.classList.add("mm-none");
		card.querySelector(".mm-sample-in-cart")?.classList.remove("mm-none");
	}
}

function mmUpdateSamplesCTA() {
	const priceDisplay = document.querySelector(".mm-product-samples-sum-price");
	if (!priceDisplay) return;
	let totalCents = 0;

	mmSelectedSamples.forEach(function(variantId) {
		if (!mmCartSamples.has(variantId)) {
			const card = document.querySelector(".mm-product-samples-modal [data-variant-id=\"" + variantId + "\"]");
			if (card) {
				const price = parseInt(card.dataset.price, 10);
				if (!isNaN(price)) totalCents += price;
			}
		}
	});

	priceDisplay.textContent = totalCents > 0 ? "– " + Math.round(totalCents / 100) + " €" : "";
}

function mmSyncSamplesWithCart() {
	return fetch("/cart.js")
		.then(function(res) { return res.json(); })
		.then(function(cart) {
			mmCartSamples.clear();
			mmSelectedSamples.clear();

			cart.items.forEach(function(item) {
				const variantId = item.variant_id.toString();
				if (window.mmSampleIds && window.mmSampleIds.has(variantId)) {
					mmCartSamples.add(variantId);
					mmSelectedSamples.add(variantId);
				}
			});

			// Wrapper : afficher uniquement les cards en panier
			document.querySelectorAll(".mm-product-samples-wrapper [data-variant-id]").forEach(function(card) {
				const variantId = card.dataset.variantId;
				if (mmCartSamples.has(variantId)) {
					card.classList.remove("mm-none");
					if (!card.dataset.boundHover) {
						const removeBtn = card.querySelector(".mm-sample-remove-btn");
						if (removeBtn) {
							card.addEventListener("mouseenter", function() { removeBtn.style.display = "block"; });
							card.addEventListener("mouseleave", function() { removeBtn.style.display = "none"; });
						}
						card.dataset.boundHover = "true";
					}
				} else {
					card.classList.add("mm-none");
				}
			});

			// Modal : reset puis marquer l'état de chaque card
			if (window.mmSampleIds) {
				window.mmSampleIds.forEach(function(id) {
					mmSetModalCardState(id, mmCartSamples.has(id) ? "in-cart" : "default");
				});
			}

			mmUpdateSamplesCTA();
		})
		.catch(function(error) {
			console.error("Erreur sync panier samples :", error);
		});
}

function addSelectedSamplesToCart() {
	if (mmSelectedSamples.size === 0) {
		alert("Veuillez sélectionner au moins un échantillon.");
		return;
	}

	const newItems = Array.from(mmSelectedSamples)
		.filter(function(id) { return !mmCartSamples.has(id); })
		.map(function(id) { return { id: id, quantity: 1 }; });

	if (newItems.length === 0) {
		alert("Ces échantillons sont déjà dans votre panier.");
		return;
	}

	fetch("/cart/add.js", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ items: newItems }),
	})
	.then(function(response) {
		if (!response.ok) throw new Error("Erreur lors de l'ajout au panier");
		return response.json();
	})
	.then(function(data) {
		const lastSample = data.items[data.items.length - 1];
		const imageUrl = (lastSample && lastSample.featured_image && lastSample.featured_image.url) || "";
		showGroupedToast(data.items.length, imageUrl);
		updateCartCount();
		mmSyncSamplesWithCart().then(mmCloseSamplesModal);
	})
	.catch(function(error) {
		console.error("Erreur ajout samples :", error);
	});
}

function mmDestroySampleFromCartByVariantId(variantId) {
	mmAPIRequest("POST", "cart/change.js", { id: variantId, quantity: 0 })
		.then(function() {
			mmSyncSamplesWithCart();
			updateCartCount();
		})
		.catch(function(error) {
			console.error("Erreur suppression sample :", error);
		});
}

document.addEventListener("DOMContentLoaded", function() {
	// Flèche de scroll du wrapper
	const wrapper = document.querySelector(".mm-product-samples-wrapper");
	const btnRight = document.querySelector(".mm-scroll-arrow-right");

	if (wrapper && btnRight) {
		function updateArrowVisibility() {
			const isAtEnd = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 1;
			btnRight.style.display = (wrapper.scrollWidth > wrapper.clientWidth && !isAtEnd) ? "block" : "none";
		}
		btnRight.addEventListener("click", function() { wrapper.scrollBy({ left: 300, behavior: "smooth" }); });
		wrapper.addEventListener("scroll", updateArrowVisibility);
		window.addEventListener("resize", updateArrowVisibility);
		new MutationObserver(updateArrowVisibility).observe(wrapper, { childList: true, attributeFilter: ["class"] });
	}

	// Sync initial
	if (window.mmSampleIds) {
		mmSyncSamplesWithCart();
	}
});

